import { Speaker } from '../types';

// Speaker colors for different speakers (using CSS color values for fill)
const SPEAKER_COLORS = [
  '#2563eb', // blue-600
  '#16a34a', // green-600
  '#9333ea', // purple-600
  '#ea580c', // orange-600
  '#dc2626', // red-600
  '#db2777', // pink-600
  '#4f46e5', // indigo-600
  '#0d9488', // teal-600
];

// Function to get speaker color based on index
export const getSpeakerColor = (speakerId: string, speakers: Speaker[]) => {
  const index = speakers.findIndex((s) => s.id === speakerId);
  return SPEAKER_COLORS[index % SPEAKER_COLORS.length];
};
